/**
 * Adjetivos: the answer, and how the word agrees.
 */
import { TranslationCardBack } from '@/components/practice/TypeTranslationCard';

import type { CardBackProps } from '../types';

import { AgreementRow } from './AgreementRow';
import type { AdjetivoPayload } from './types';

export function CardBack({
  card,
  correct,
  primary_lang,
  secondary_lang,
  isLastCard,
  onNext,
}: CardBackProps<AdjetivoPayload>) {
  return (
    <TranslationCardBack
      card={card}
      correct={correct}
      primary_lang={primary_lang}
      secondary_lang={secondary_lang}
      isLastCard={isLastCard}
      onNext={onNext}
      headword={card.de}
      detail={<AgreementRow payload={card.payload} />}
    />
  );
}
